import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Col, Modal, Row } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";

import classes from "./Modal.module.css";
import Loader from "../SharedComponents/Loader/Loader";
import { CatchMessage, JSONtoformdata } from "../Shared/Methods";
import { PasswordExp } from "../Shared/Constants";
import CommonPasswordInput from "../Components/CommonForms/CommonPasswordInput";
import CommonButton from "../Components/Buttons/CommonButton";
import { handleloading } from "../Store/Redux/Reducers/Dashboardreducers";
import { ChangePasswprd, ChangeUserPassword } from "../Services/ApiServices";

interface props {
  open: boolean;
  closable: boolean;
  onCancel: () => void;
  handleSuccess?: () => void;
  item?: any;
  isuserpassword?: boolean;
}

interface formikprops {
  old_password: string;
  new_password: string;
  repeat_password: string;
  password: string;
  Userpassword: boolean;
  user_id: string;
  passwordName: string;
}

function ChangePasswordModal({
  open,
  closable,
  onCancel,
  handleSuccess,
  item = "",
  isuserpassword = true,
}: props) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);
  const dispatch = useDispatch();
  // const [passwordName, setPasswordName] = useState("new_password");

  const Validattion = Yup.object().shape({
    Userpassword: Yup.boolean(),
    passwordName: Yup.string(),
    old_password: Yup.string().when("Userpassword", {
      is: (Userpassword: any) => {
        return Userpassword;
      },
      then: () =>
        Yup.string()
          .min(5, "Password should contain at least 5 characters.")
          .matches(
            PasswordExp,
            "Password must contain at least one lower and upper case character and a digit"
          )
          .required("Password can't be blank."),
    }),

    new_password: Yup.string().when("Userpassword", {
      is: (Userpassword: any) => Userpassword,
      then: () =>
        Yup.string()
          .min(5, "Password should contain at least 5 characters.")
          .matches(
            PasswordExp,
            "Password must contain at least one lower and upper case character and a digit"
          )
          .required("New Password can't be blank"),
    }),

    repeat_password:
      // Yup.string()
      // .when("Userpassword", {
      //   is: (Userpassword: any) => Userpassword,
      //   then: () =>
      Yup.string()
        .when(`passwordName`, (passwordName, field) => {
          return passwordName
            ? field.oneOf(
                [Yup.ref(`${passwordName}`), undefined],
                `Confirm Password must be equal to ${
                  isuserpassword ? "New Password" : "Password"
                }`
              )
            : field;
        })
        .required("Confirm Password can't be blank."),
    // }),

    password: Yup.string().when("Userpassword", {
      is: (Userpassword: any) => {
        return Userpassword === false ? true : false;
      },
      then: () =>
        Yup.string()
          .min(5, "Password should contain at least 5 characters")
          .matches(
            PasswordExp,
            "Password must contain at least one lower and upper case character and a digit"
          )
          .required("Password is required"),
    }),
  });

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    handleChange,
    handleBlur,
    setValues,
  } = useFormik({
    initialValues: {
      old_password: "",
      new_password: "",
      repeat_password: "",
      password: "",
      Userpassword: true,
      user_id: "",
      passwordName: "new_password",
    },
    validationSchema: Validattion,
    onSubmit: (values, formikHelpers) => {
      if (values?.Userpassword) {
        handleChangePassword();
      } else {
        handleUserChangePassword();
      }
    },
  });

  useEffect(() => {
    if (item) {
      setValues({
        ...values,
        Userpassword: isuserpassword,
        user_id: item?.id || "",
        passwordName: "password",
      });
      // setPasswordName("password");
    }
  }, [item]);

  const handleChangePassword = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...values,
    };

    const finalData = { ...finalObj } as Partial<formikprops>;
    delete finalData?.Userpassword;
    delete finalData?.passwordName;

    ChangePasswprd(JSONtoformdata(finalData))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          toast.success(res?.data?.msg);
          onCancel();
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const handleUserChangePassword = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...values,
    };

    const finalData = { ...finalObj } as Partial<formikprops>;
    delete finalData?.Userpassword;
    delete finalData?.passwordName;
    delete finalData?.repeat_password;

    ChangeUserPassword(JSONtoformdata(finalData))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          toast.success(res?.data?.msg);
          onCancel();
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      <Loader isLoader={loading} />
      <Modal open={open} closable={closable} width={500} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>Change Password</h4>
          <Row gutter={[16, 16]}>
            {values?.Userpassword ? (
              <>
                <Col sm={12} xs={12}>
                  <CommonPasswordInput
                    name="old_password"
                    values={values?.old_password}
                    onChange={({ target }) => {
                      if (!target.value.includes(" ")) {
                        setFieldValue("old_password", target.value);
                      }
                    }}
                    required={true}
                    type="password"
                    labelname="Old Password"
                    error={errors}
                    touched={touched}
                  />
                </Col>
                <Col sm={12} xs={12}>
                  <CommonPasswordInput
                    name="new_password"
                    values={values?.new_password}
                    onChange={({ target }) => {
                      if (!target.value.includes(" ")) {
                        setFieldValue("new_password", target.value);
                      }
                    }}
                    required={true}
                    type="password"
                    labelname="New Password"
                    error={errors}
                    touched={touched}
                  />
                </Col>
              </>
            ) : null}

            {values?.Userpassword ? null : (
              <Col sm={12} xs={12}>
                <CommonPasswordInput
                  name="password"
                  values={values?.password}
                  onChange={({ target }) => {
                    if (!target.value.includes(" ")) {
                      setFieldValue("password", target.value);
                    }
                  }}
                  required={true}
                  type="password"
                  labelname="Password"
                  error={errors}
                  touched={touched}
                />
              </Col>
            )}

            <Col sm={12} xs={12}>
              <CommonPasswordInput
                name="repeat_password"
                values={values?.repeat_password}
                onChange={({ target }) => {
                  if (!target.value.includes(" ")) {
                    setFieldValue("repeat_password", target.value);
                  }
                }}
                required={true}
                type="password"
                labelname="Confirm Password"
                error={errors}
                touched={touched}
              />
            </Col>
          </Row>
          <div className={classes.modal_button_container}>
            <CommonButton
              name="Submit"
              onClick={handleSubmit}
              type="submit"
              classname="submit_btn"
            />
            <CommonButton
              name="Cancel"
              type="button"
              onClick={() => onCancel()}
              // style={{ backgroundColor: "#eb3131" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ChangePasswordModal;
